module.exports = __webpack_public_path__ + "static/img/operation.1f22f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/operation.png
// module id = x3WB
// module chunks = 1